import { SBPBanks } from "../initializeSBPBanks/data";
export var getSBPBanks = function getSBPBanks() {
  return SBPBanks.getInstance().getData();
};